import {Badge} from '@/components/ui/badge/Badge'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledConversationFilters = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        padding-top: ${spacing * 2}px;
    `
)

export const StyledBadgeButton = styled(Badge)(
    () => css`
        cursor: pointer;
    `
)
